//////////////////////////////////////////////////////          //////////////////////////////////////////////////////
//                                                  //          //                                                  //
//  PARA CLIENTES:                                  //          //  PARA FRANQUEADOS:                               //
//                                                  //          //                                                  //
//  APARECE COMO BOTÃO DE                           //          //  APARECE COMO BOTÃO DE                           //
//  SACOLA/CARRINHO EM TODOS OS HEADERS             //          //  DADOS EM TODOS OS HEADERS                       //
//                                                  //          //                                                  //
//  FUNCIONALIDADE: ABRIR A ABA LATERAL             //          //  FUNCIONALIDADE: ABRIR O DROPDOWN COM AS OPÇÕES  //
//    DIREITA DO CARRINHO PARA PODER VER            //          //    TROCAR SENHA, DEFINIR ESTOQUE DE SEGURANCA,   //
//    OS PRODUTOS QUE SERÃO COMPRADOS               //          //    VER PEDIDOS E CARRINHOS DOS CLIENTES DA LOJA  //
//                                                  //          //                                                  //
//////////////////////////////////////////////////////          ////////////////////////////////////////////////////// 



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/components/continuar_comprando.js                  //
//      frontend/src/components/header.js                               //
//      frontend/src/components/mock_picture.js                         //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import '../../assets/css/local/header.css';

function CarrinhoButton() {
    if(sessionStorage['login']){  // CASO O USUARIO ESTEJA LOGADO
        if(!sessionStorage['login'].includes('/')){  // COMO CLIENTE
            return (  // RENDERIZA O ÍCONE DE SACOLA
                <div className="col-md-2 col-1">
                    <div className="d-none d-lg-block header-size">
                        <button className="btn-verde my-1 w-100 montserrat" onClick={open_carrinho}>
                            <i className="fa fa-shopping-bag mr-4"></i>
                            Sacola
                        </button>
                    </div>
                    <div className="d-lg-none header-size">
                        <button className="carrinho-pqn-header my-1" onClick={open_carrinho}>
                            <i className="fa fa-shopping-bag"></i>
                        </button>
                    </div>
                </div>
            );
        }
        else{  // CASO ESTEJA LOGADO COMO FRANQUEADO
            return (  // RENDERIZA O ÍCONE DE DADOS + DROPDOWN COM OPÇÕES DE PERFIL
                    <div className="col-md-2 col-1">
                        <div className="d-none d-lg-block header-size">
                            <button className="btn-verde my-1 w-100 montserrat" onClick={dropdown}>
                                <i className="fa fa-address-book-o mr-4"></i>
                                Dados
                            </button>                            
     
                        </div>
                        <div className="d-lg-none header-size">
                            <button className="carrinho-pqn-header my-1" onClick={dropdown}>
                                <i className="fa fa-address-book-o"></i>
                            </button>                        
                        </div>
                        <div class='dropdown_header montserrat d-none' id='dropdown'>
                            <div class='p-2 item_header' onClick={trocar_senha}>
                                <div class='subitem_header'>Trocar Senha</div>
                            </div>
                            <div class='p-2 item_header' onClick={estoque_seguranca}>
                                <div class='subitem_header'>Estoque de Segurança</div>
                            </div>                            
                            <div class='p-2 item_header' onClick={pedidos}>
                                <div class='subitem_header'>Pedidos</div>
                            </div>
                            <div class='p-2 item_header' onClick={dados}>
                                <div class='subitem_header'>Carrinhos</div>
                            </div>
                        </div> 
                    </div>
            );        
        }

    }
    else{  // CASO NÃO ESTEJA LOGADO, RENDERIZA A SACOLA PORÉM O CARRINHO FICA VAZIO
        return (
            <div className="col-md-2 col-1">
            <div className="d-none d-lg-block header-size">
                <button className="btn-verde my-1 w-100 montserrat" onClick={open_carrinho}>
                    <i className="fa fa-shopping-bag mr-4"></i>
                    Sacola
                </button>
            </div>
            <div className="d-lg-none header-size">
                <button className="carrinho-pqn-header my-1" onClick={open_carrinho}>
                    <i className="fa fa-shopping-bag"></i>
                </button>
            </div>
        </div>
        );        
    }
}

function open_carrinho(){
    document.getElementById("body_proj").classList.add('hide-scroll')
    document.getElementById("itens").classList.remove('d-none')
}

function dropdown(){  // FUNÇÃO QUE ABRE O DROPDOWN DAS OPÇÕES DE PERFIL
    // FUNÇÃO CHAMADA NO CLICK DO BOTÃO DE DADOS DESSE COMPONENTE

    if (document.getElementById('dropdown').classList.contains('d-none')){
        document.getElementById('dropdown').classList.remove('d-none')
    }
    else{
        document.getElementById('dropdown').classList.add('d-none')
    }
}

function estoque_seguranca(){  // FUNÇÃO QUE REDIRECIONA PARA A PÁGINA DE ESTOQUE DE SEGURANÇA (DEFINIR ESTOQUE DE SEGUURANÇA)
    // FUNÇÃO CHAMADA NO CLICK DA OPÇÃO DE 'Estoque de Segurança' DO DROPDOWN DO BOTÃO DE PERFIL DESSE COMPONENTE 
    // SÓ UTILIZÁVEL EM CASO DE LOGIN COMO FRANQUEADO

    var id = sessionStorage['loja']
    
    window.location.href = '/estoque_seguranca/?loja=' + id    
}

function dados(){  // FUNÇÃO QUE REDIRECIONA PARA A PÁGINA DE DADOS (VER CARRINHOS DOS CLIENTES)
    // FUNÇÃO CHAMADA NO CLICK DA OPÇÃO DE 'Carrinhos' DO DROPDOWN DO BOTÃO DE PERFIL DESSE COMPONENTE
    // SÓ UTILIZÁVEL EM CASO DE LOGIN COMO FRANQUEADO

    var id = sessionStorage['loja']
    
    window.location.href = '/interesses/?loja=' + id

}

function pedidos(){  // FUNÇÃO QUE REDIRECIONA PARA A PÁGINA DE PEDIDOS (VER CPEDIDOS FINALIZADOS POR CLIENTES)
    // FUNÇÃO CHAMADA NO CLICK DA OPÇÃO DE 'Pedidos' DO DROPDOWN DO BOTÃO DE PERFIL DESSE COMPONENTE
    // SÓ UTILIZÁVEL EM CASO DE LOGIN COMO FRANQUEADO

    var id = sessionStorage['loja']
    
    window.location.href = '/pedidos/?loja=' + id

}

function trocar_senha(){  // FUNÇÃO QUE REDIRECIONA PARA A PÁGINA DE SENHA (TROCAR SENHA)
    // FUNÇÃO CHAMADA NO CLICK DA OPÇÃO DE 'Trocar Senha' DO DROPDOWN DO BOTÃO DE PERFIL DESSE COMPONENTE
    // SÓ UTILIZÁVEL EM CASO DE LOGIN COMO FRANQUEADO.
    // O BOTÃO PARA REDIRECIONAR CLIENTES PARA A TROCA DE SENHA 
        // FICA NO ARQUIVO 'frontend/src/components/header/logout_button.js'

    var id = sessionStorage['loja']
    
    window.location.href = '/trocar_senha/?loja=' + id

}

export default CarrinhoButton;
  